export default "__VITE_ASSET__C87VJPeH__"